export default __webpack_public_path__ + "static/media/r3.53c94d18.jpg";